import { Injectable } from '@angular/core';
import { ClientLookupOption } from '../../domain/models/client-lookup-option.model';
import { PagedClientLookupDto } from '../dtos/client-lookup.dto';

function extractTrailingId(url: string | null): string | null {
  if (!url) return null;
  const trimmed = url.replace(/\/+$/, '');
  const lastSlash = trimmed.lastIndexOf('/');
  return lastSlash >= 0 && lastSlash < trimmed.length - 1 ? trimmed.slice(lastSlash + 1) : trimmed || null;
}

@Injectable()
export class ClientLookupMapper {
  public toOptions(dto: PagedClientLookupDto): readonly ClientLookupOption[] {
    return dto.Items.map((item) => ({
      externalId: item.ExternalId,
      firstName: item.FirstName ?? '',
      lastName: item.LastName ?? '',
      email: item.Email,
      homeDepartmentExternalId: extractTrailingId(item.HomeDepartmentUrl),
    }));
  }
}
